import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';

import { WorldMapService } from './world-map.service';

@Injectable()
export class WorldMapSizeResolver implements Resolve<{ width: number; height: number; }> {
    constructor(
        private _worldMapService: WorldMapService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        const { shard } = route.params;

        return new Promise(async (resolve) => {
            try {
                const { width, height } = await this._worldMapService.getWorldSize(shard);

                resolve({ width, height });
            } catch (err) {
                // TODO: Need to add handler for world status error.
                // reject();
            }
        });
    }
}
